import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "sonner";
import { useAuth } from "./contexts/auth/AuthContext";
import { AuthProvider } from "./contexts/auth/AuthProvider";
import { ThemeProvider } from "./contexts/theme/ThemeProvider";
import "./lib/i18n";
import { queryClient } from "./lib/query-client";
import { initSentry } from "./lib/sentry";
import { createAppRouter } from "./router";

const AppRouter = () => {
  const auth = useAuth();
  const [router] = useState(() => createAppRouter({ auth }));

  useEffect(() => {
    router.update({ context: { auth } });
  }, [router, auth]);

  return <RouterProvider router={router} />;
};

initSentry();

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <Toaster richColors position="bottom-right" theme="system" />
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}
